import { Box } from "@mui/material";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { Outlet, useMatch } from "react-router-dom";
import { useAuthContext } from "features/auth/AuthContext";
import MainNavigation from "features/navigation/MainNavigation";
import theme from "CustomMuiTheme";
import { ToastContainer } from "react-toastify";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const { user } = useAuthContext();
  const userIsVerified = user?.state !== "CREATED";
  const userIsApproved = user?.state !== "PENDING";
  const viewReportMode = useMatch("/report/:slug");

  const showNavigation = user !== null && userIsVerified && userIsApproved && !viewReportMode;

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-center" />

      <Box
        sx={{
          display: "grid",
          gridTemplateAreas: '"nav" "main"',
          gridTemplateRows: "auto 1fr",
          height: "100vh",
          [theme.breakpoints.up("lg")]: {
            gridTemplateAreas: '"nav main"',
            gridTemplateColumns: "auto 1fr",
            gridTemplateRows: "unset",
          },
        }}
      >
        {showNavigation && <MainNavigation />}

        <Box
          id="scrollContainer"
          sx={{
            gridArea: "main",
            overflowY: "scroll",
            overflowX: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default App;
